import React, { useEffect, useState } from 'react';
import useStyles from './style';
import { Box } from '@material-ui/core';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import AdCalendarCarouselType2 from '../../../components/organism/AdCalendarCarouselType2';
import Typography from '../../../components/atoms/Typography';
import { get } from 'lodash';
import fetchService from '../../../../services/FetchService';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { getUId } from '../../../../utils/utility';
import { COMPONENT_NAME } from './locators';

const Top10Events = (props) => {
  const { fields, appConfig, sitecoreContext } = props;
  const [response, setResponse] = useState('');
  const uid = getUId(props)
  const language = get(sitecoreContext, 'language', 'en');
  const title = get(props, 'rendering.fields.title.value', '');
  const limit = get(fields, 'limit.value', '10');
  const result = get(props, 'fields.topTenList', []);
  const BGColor = get(props, 'fields.bgColor.fields.colorCode.value', '#009086');
  const classes = useStyles();

  const numberingColor = get(fields, 'numberingColor.fields.colorCode.value', '')

  return (
    <Box className={`${classes.Top10Events} ${BGColor ? 'withBG' : ''}`} style={{ backgroundColor: BGColor }} data-locator={COMPONENT_NAME} uid={uid}>
      <Typography className={'eventsTitle'} variant={'h5'}>{title}</Typography>
      <AdCalendarCarouselType2 {...props} numberingColor={numberingColor} result={result} language={language} />
    </Box>
  )
};

export default withSitecoreContext()(Top10Events);
